import React, { Component } from "react";
import { Map, Marker, GoogleApiWrapper } from "google-maps-react";
import { LoadPanel } from "devextreme-react/load-panel";

export class MapContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      latitude: -5.19853,
      longitude: -40.669,
    };
  }

  componentDidUpdate() {
    if (
      this.state.latitude !== this.props.latitude ||
      this.state.longitude !== this.props.longitude
    ) {
      this.setState({
        latitude: this.props.latitude,
        longitude: this.props.longitude,
      });
    }
  }

  render() {
    const style = {
      width: "100%",
      height: "100%",
    };
    return (
      <Map
        google={this.props.google}
        style={style}
        initialCenter={{
          lat: this.state.latitude,
          lng: this.state.longitude,
        }}
        center={{ lat: this.state.latitude, lng: this.state.longitude }}
        zoom={15}
      >
        <Marker
          title={"Localização do imóvel selecionado"}
          name={"Imóvel"}
          position={{
            lat: this.latitude || this.defaultLatitude,
            lng: this.longitude || this.defaultLongitude,
          }}
        />
      </Map>
    );
  }
}

const LoadingContainer = (props) => {
  return <LoadPanel shadingColor="rgba(0,0,0,0.4)" visible={!props.loaded} />;
};

export default GoogleApiWrapper({
  apiKey: "AIzaSyB7A6EmsThIumxi7WzfVMFrEHWfLxGxC1A",
  language: "PTBR",
  LoadingContainer: LoadingContainer,
})(MapContainer);
